/**
 * @generated SignedSource<<f029b08ed0cb9f311844e9920dd81fa5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMeta_charge$data = {
  readonly identifier: string | null | undefined;
  readonly metaPixel: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly status: string | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "useMeta_charge";
};
export type useMeta_charge$key = {
  readonly " $data"?: useMeta_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMeta_charge">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useMeta_charge"
};

(node as any).hash = "c591da6a4b367074b4904fb96a5b9b74";

export default node;
